export default function AboutSection() {
  return (
    <section id="about" className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] lg:aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Flowing%20translucent%20fabric%20curtains%20made%20of%20pure%20light%20suspended%20in%20cosmic%20void%2C%20warm%20champagne%20and%20soft%20ivory%20gradients%2C%20dreamy%20ethereal%20atmosphere%2C%20scattered%20stardust%20particles%2C%20minimal%20clean%20feminine%20aesthetic%2C%20fine%20art%20editorial%20photography%2C%20high%20key%20lighting%20with%20gentle%20glow%2C%20elegant%20serene%20composition&width=900&height=1200&seq=rse-about-image&orientation=portrait"
                alt="合同会社RSE - 代表メッセージ"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-[0.2em] mb-5">
              ABOUT
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-900 tracking-wide mb-6 leading-tight">
              代表メッセージ
            </h2>
            <p className="text-foreground-600 text-base leading-loose mb-6">
              テクノロジーは、そこに込められた思いによって人と人をつなぎ、未来を明るく照らす光となります。
              私たち合同会社RSEは、ソフトウェア開発・ITコンサルティング・Web制作の各領域において、
              お客様一人ひとりのビジョンに真摯に向き合い、クリーンで洗練されたソリューションをお届けします。
            </p>
            <p className="text-foreground-600 text-base leading-loose mb-8">
              女性ならではの細やかな視点と感性を活かし、テクノロジーの力で社会に新しい価値を創造すること。
              それが私たちの使命です。
            </p>
            <div className="border-t border-background-300 pt-6 space-y-2">
              <div className="flex items-start gap-4">
                <span className="text-foreground-400 text-sm w-20 shrink-0">代表社員</span>
                <span className="text-foreground-800 text-sm font-medium">高野 友加里</span>
              </div>
              <div className="flex items-start gap-4">
                <span className="text-foreground-400 text-sm w-20 shrink-0">所在地</span>
                <span className="text-foreground-800 text-sm">
                  〒161-0033 東京都新宿区下落合一丁目15番20-801号
                </span>
              </div>
              <div className="flex items-start gap-4">
                <span className="text-foreground-400 text-sm w-20 shrink-0">設立</span>
                <span className="text-foreground-800 text-sm">合同会社RSE</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}